<template>
   <!-- ----------------------------------------------------------------------------- -->
   <!-- DatatablesCRUDActions -->
   <!-- ----------------------------------------------------------------------------- -->
   <div>
      <v-list-item-subtitle class="text-wrap">

      </v-list-item-subtitle>
      <v-data-table :headers="headers" :items="filteredItems" sort-by="no" class="border">
         <template v-slot:top>
            <v-toolbar flat color="white">
               <v-toolbar-title>Membership</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
               <v-spacer></v-spacer>
               <v-btn color="teal darken-1" dark class="mb-2 mr-2" @click="openBulkReminder">
                  <v-icon left small>mdi-email-multiple-outline</v-icon>
                  Renewal Reminders
               </v-btn>
               <v-btn color="primary" dark class="mb-2 mr-2" @click="dlglisting = true">
                  <v-icon left small>mdi-view-list</v-icon>
                  View Listing
               </v-btn>
               <v-btn color="primary" dark class="mb-2" @click="newItem">New Membership</v-btn>
            </v-toolbar>
            <v-row dense class="px-2 membership-filter-row">
               <v-col cols="12" md="6">
                  <v-text-field
                     v-model="search"
                     label="Search"
                     solo
                     dense
                     clearable
                     prepend-inner-icon="mdi-magnify"
                     hide-details
                  ></v-text-field>
               </v-col>
               <!-- <v-col cols="12" md="2">
                  <v-select
                     :items="searchfields"
                     v-model="searchfield"
                     solo
                     dense
                     label="Search By"
                     item-text="text"
                     item-value="value"
                     hide-details
                  ></v-select>
               </v-col> -->
               <v-col cols="12" md="3">
                  <v-select
                     :items="optfiltertypes"
                     clearable
                     label="Filter By Member Type"
                     item-text="title"
                     item-value="membertype"
                     v-model="filtertype"
                     solo
                     dense
                     hide-details
                  />
               </v-col>
               <v-col cols="12" md="3">
                  <v-select
                     :items="optfilterstatus"
                     clearable
                     type="number"
                     label="Filter By Member Status"
                     item-text="title"
                     item-value="memberstatus"
                     v-model="filterstatus"
                     solo
                     dense
                     hide-details
                  />
               </v-col>
            </v-row>
         </template>
         <template v-slot:[`item.membertype`]="{ item }">
            <v-chip color="cyan lighten-1" small label text-color="white">{{ formattype(item.membertype) }}</v-chip>
         </template>
         <template v-slot:[`item.memberstatus`]="{ item }">
            <v-chip :color="formatstatuscolor(item.memberstatus)" small label text-color="white">{{ formatstatus(item.memberstatus) }}</v-chip>
         </template>
         <template v-slot:[`item.outstanding_fee`]="{ item }">
            <div class="outstanding-cell">
               <v-chip
                  v-if="hasOutstandingFee(item)"
                  class="outstanding-chip overdue"
                  small
                  label
                  text-color="white"
               >
                  {{ formatMoney(item.outstanding_amount) }}
               </v-chip>
               <v-chip
                  v-else
                  class="outstanding-chip"
                  :color="item.outstanding_status === 'not_applicable' ? 'blue-grey lighten-2' : 'green darken-1'"
                  small
                  label
                  text-color="white"
               >
                  {{ item.outstanding_status === 'not_applicable' ? 'N/A' : 'Clear' }}
               </v-chip>
               <div class="outstanding-detail">
                  {{ outstandingText(item) }}
               </div>
            </div>
         </template>
         <template v-slot:[`item.actions`]="{ item }">
            <div class="membership-actions">
               <v-icon class="mr-1" title="Edit Membership" @click="editItem(item)">mdi-pencil</v-icon>
               <v-icon class="mr-1" title="View/print" @click="viewItem(item)">mdi mdi-printer-search</v-icon>
               <v-icon class="mr-1" title="Reset Password" @click="confirmResetPassword(item)">mdi mdi-lock-check</v-icon>
               <v-btn
                  color="orange darken-2"
                  dark
                  x-small
                  class="mr-1"
                  title="Send expired membership reminder"
                  @click="confirmExpiredReminder(item)"
               >
                  <v-icon left x-small>mdi-email-alert-outline</v-icon>
                  Reminder
               </v-btn>
               <!-- <v-icon class="mr-2" title="Corporate Application Info" @click="openCorporateInfo(item)">mdi-card-account-details-outline</v-icon> -->
               <v-icon class="mr-1" title="Delete" @click="confirmDelete(item)">mdi-delete</v-icon>
               <!-- <v-icon class="mr-2" title="Print Membership" @click="printItem(item)">mdi-printer</v-icon> -->
            </div>
         </template>
      </v-data-table>
      <dialog-member-edit ref="dlgedit" v-on:MembershipApproved="onMembershipApproved" v-on:MembershipUpdated="onMembershipUpdated"></dialog-member-edit>
      <dialog-member-new ref="dlgnew" v-on:MemberAdded="initialize"></dialog-member-new>
      
      <v-dialog v-model="dlgview" fullscreen hide-overlay transition="dialog-bottom-transition">
         <v-card>
            <v-toolbar dark class="membership-view-toolbar">
               <v-btn icon dark @click="dlgview = false">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
               <v-toolbar-title>View Membership</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn color="primary" dark small @click="printSelectedMember">
                  <v-icon left small>mdi-printer</v-icon>
                  Print
               </v-btn>
            </v-toolbar>

            <div v-if="viewLoading" class="membership-view-loading pa-8 text-center">
               <v-progress-circular indeterminate color="primary"></v-progress-circular>
               <div class="caption mt-3 grey--text text--darken-1">Loading membership record...</div>
            </div>

            <div v-else-if="selectedMember" id="membership-print-area" class="membership-view pa-4">
               <div class="membership-brand-panel">
                  <div class="membership-brand-copy">
                     <img src="/images/miplogo-300x300.png" class="membership-brand-logo" alt="MIP logo" />
                     <div>
                        <div class="membership-brand-kicker">Malaysian Institute of Planners</div>
                        <div class="membership-brand-title">MIP Online Membership System</div>
                        <div class="membership-brand-subtitle">Official Membership Profile Record</div>
                     </div>
                  </div>
                  <div class="membership-brand-status">
                     <div class="membership-status-card-label">Membership Standing</div>
                     <div class="membership-status-chips">
                        <span class="membership-chip membership-chip-type">{{ formattype(selectedMember.membertype) || '-' }}</span>
                        <span class="membership-chip membership-chip-active">{{ formatstatus(selectedMember.memberstatus) || '-' }}</span>
                     </div>
                  </div>
               </div>

               <div class="membership-member-panel">
                  <img :src="memberImage(selectedMember)" class="membership-member-photo" />
                  <div>
                     <div class="membership-view-kicker">Member Profile</div>
                     <h2 class="membership-view-title">{{ selectedMember.fullname || '-' }}</h2>
                     <div class="membership-profile-chips">
                        <span class="membership-chip membership-chip-type">{{ formattype(selectedMember.membertype) || '-' }}</span>
                        <span class="membership-chip membership-chip-active">{{ formatstatus(selectedMember.memberstatus) || '-' }}</span>
                     </div>
                     <div class="membership-view-meta">
                        <span>Member ID: {{ selectedMember.memberid || 'Not assigned' }}</span>
                        <span>IC / Passport: {{ selectedMember.icpassport || '-' }}</span>
                        <span>Email: {{ selectedMember.contactemail || '-' }}</span>
                     </div>
                  </div>
               </div>

               <v-divider class="mb-4"></v-divider>

               <section class="membership-section">
                  <div class="membership-section-title">General Membership Information</div>
                  <div class="membership-field"><span>Member ID</span><strong>{{ selectedMember.memberid || '-' }}</strong></div>
                  <div class="membership-field"><span>LPBM No.</span><strong>{{ lpbmNo(selectedMember) }}</strong></div>
                  <div class="membership-field"><span>Member Type</span><strong>{{ formattype(selectedMember.membertype) || '-' }}</strong></div>
                  <div class="membership-field"><span>Membership Status</span><strong>{{ formatstatus(selectedMember.memberstatus) || '-' }}</strong></div>
                  <div class="membership-field"><span>Date Applied</span><strong>{{ displayDate(selectedMember.dateapplied) }}</strong></div>
                  <div class="membership-field"><span>Date Approved</span><strong>{{ displayDate(selectedMember.dateapproved) }}</strong></div>
                  <div class="membership-field"><span>Date Payment (Registration)</span><strong>{{ displayDate(selectedMember.datepayment) }}</strong></div>
                  <div class="membership-field"><span>Valid Until</span><strong>{{ displayDate(selectedMember.datevalid) }}</strong></div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Personal Details</div>
                  <div class="membership-field"><span>Full Name</span><strong>{{ selectedMember.fullname || '-' }}</strong></div>
                  <div class="membership-field"><span>IC / Passport No.</span><strong>{{ selectedMember.icpassport || '-' }}</strong></div>
                  <div class="membership-field"><span>Contact No.</span><strong>{{ selectedMember.contactmobile || '-' }}</strong></div>
                  <div class="membership-field"><span>Email</span><strong>{{ selectedMember.contactemail || '-' }}</strong></div>
                  <div class="membership-field"><span>Gender</span><strong>{{ selectedMember.gender || '-' }}</strong></div>
                  <div class="membership-field"><span>Nationality</span><strong>{{ selectedMember.nationality || '-' }}</strong></div>
                  <div class="membership-field"><span>Race</span><strong>{{ selectedMember.race || '-' }}</strong></div>
                  <div class="membership-field"><span>Religion</span><strong>{{ selectedMember.religion || '-' }}</strong></div>
                  <div class="membership-field"><span>Date of Birth</span><strong>{{ displayDate(selectedMember.dob) }}</strong></div>
                  <div class="membership-field"><span>Age</span><strong>{{ memberAge(selectedMember.dob) }}</strong></div>
                  <div class="membership-field"><span>Place of Birth</span><strong>{{ selectedMember.pob || '-' }}</strong></div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Home Address</div>
                  <div class="membership-field"><span>Address</span><strong>{{ selectedMember.homestreet || '-' }}</strong></div>
                  <div class="membership-field"><span>Postcode</span><strong>{{ selectedMember.homepostcode || '-' }}</strong></div>
                  <div class="membership-field"><span>City</span><strong>{{ selectedMember.homecity || '-' }}</strong></div>
                  <div class="membership-field"><span>District</span><strong>{{ selectedMember.homedistrict || '-' }}</strong></div>
                  <div class="membership-field"><span>State</span><strong>{{ selectedMember.homestate || '-' }}</strong></div>
                  <div class="membership-field"><span>Country</span><strong>{{ selectedMember.homecountry || '-' }}</strong></div>
                  <div class="membership-field"><span>Phone</span><strong>{{ selectedMember.homephone || '-' }}</strong></div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Practice</div>
                  <div class="membership-field"><span>Organization / Company / Practice</span><strong>{{ selectedMember.workcompany || '-' }}</strong></div>
                  <div class="membership-field"><span>Job Title</span><strong>{{ selectedMember.workjobtitle || '-' }}</strong></div>
                  <div class="membership-field"><span>Department</span><strong>{{ selectedMember.workdept || '-' }}</strong></div>
                  <div class="membership-field"><span>Position / Grade</span><strong>{{ selectedMember.workposition || '-' }}</strong></div>
                  <div class="membership-field"><span>Address</span><strong>{{ selectedMember.workstreet || '-' }}</strong></div>
                  <div class="membership-field"><span>Postcode</span><strong>{{ selectedMember.workpostcode || '-' }}</strong></div>
                  <div class="membership-field"><span>City</span><strong>{{ selectedMember.workcity || '-' }}</strong></div>
                  <div class="membership-field"><span>District</span><strong>{{ selectedMember.workdistrict || '-' }}</strong></div>
                  <div class="membership-field"><span>State</span><strong>{{ selectedMember.workstate || '-' }}</strong></div>
                  <div class="membership-field"><span>Country</span><strong>{{ selectedMember.workcountry || '-' }}</strong></div>
                  <div class="membership-field"><span>Phone</span><strong>{{ selectedMember.workphone || '-' }}</strong></div>
                  <div class="membership-field"><span>Fax</span><strong>{{ selectedMember.workfax || '-' }}</strong></div>
                  <div class="membership-field"><span>Email</span><strong>{{ selectedMember.workemail || '-' }}</strong></div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Preferred Contact Method</div>
                  <div class="membership-check-grid">
                     <div class="membership-check-item" :class="{ active: isChecked(selectedMember.prefercontacthome) }">
                        <v-icon small>{{ isChecked(selectedMember.prefercontacthome) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                        <span>Home Address</span>
                     </div>
                     <div class="membership-check-item" :class="{ active: isChecked(selectedMember.prefercontactwork) }">
                        <v-icon small>{{ isChecked(selectedMember.prefercontactwork) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                        <span>Work Address</span>
                     </div>
                     <div class="membership-check-item" :class="{ active: isChecked(selectedMember.prefercontactemail) }">
                        <v-icon small>{{ isChecked(selectedMember.prefercontactemail) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                        <span>Email</span>
                     </div>
                  </div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Education Qualification</div>
                  <div class="membership-table-wrap">
                     <table class="membership-table">
                        <thead>
                           <tr>
                              <th>No.</th>
                              <th>Qualification</th>
                              <th>University</th>
                              <th>Country</th>
                              <th>Date Commenced</th>
                              <th>Date Qualified</th>
                              <th>Document</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="item in selectedMember._qualedu" :key="'edu-' + item.id">
                              <td>{{ item.sequence || '-' }}</td>
                              <td>{{ item.qualification || '-' }}</td>
                              <td>{{ item.university || '-' }}</td>
                              <td>{{ item.country || '-' }}</td>
                              <td>{{ displayDate(item.datecommence) }}</td>
                              <td>{{ displayDate(item.datequalification) }}</td>
                              <td>{{ item.document || '-' }}</td>
                           </tr>
                           <tr v-if="!selectedMember._qualedu || !selectedMember._qualedu.length">
                              <td colspan="7" class="membership-empty">No record captured.</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Professional Qualification</div>
                  <div class="membership-table-wrap">
                     <table class="membership-table">
                        <thead>
                           <tr>
                              <th>No.</th>
                              <th>Qualification / Membership</th>
                              <th>Qualifying Body / Institute</th>
                              <th>Date Received</th>
                              <th>Date Valid</th>
                              <th>Document</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="item in selectedMember._qualpro" :key="'pro-' + item.id">
                              <td>{{ item.sequence || '-' }}</td>
                              <td>{{ item.qualname || '-' }}</td>
                              <td>{{ item.qualbodyinstname || '-' }}</td>
                              <td>{{ displayDate(item.datereceived) }}</td>
                              <td>{{ displayDate(item.datevalid) }}</td>
                              <td>{{ item.document || '-' }}</td>
                           </tr>
                           <tr v-if="!selectedMember._qualpro || !selectedMember._qualpro.length">
                              <td colspan="6" class="membership-empty">No record captured.</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Student Qualification</div>
                  <div class="membership-table-wrap">
                     <table class="membership-table">
                        <thead>
                           <tr>
                              <th>No.</th>
                              <th>Course of Study</th>
                              <th>Institution</th>
                              <th>Date Commenced</th>
                              <th>Date Completed</th>
                              <th>Document</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="item in selectedMember._qualstu" :key="'stu-' + item.id">
                              <td>{{ item.sequence || '-' }}</td>
                              <td>{{ item.course || '-' }}</td>
                              <td>{{ item.instname || '-' }}</td>
                              <td>{{ displayDate(item.datecommence) }}</td>
                              <td>{{ displayDate(item.datecomplete) }}</td>
                              <td>{{ item.document || '-' }}</td>
                           </tr>
                           <tr v-if="!selectedMember._qualstu || !selectedMember._qualstu.length">
                              <td colspan="6" class="membership-empty">No record captured.</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Employment Experience</div>
                  <div class="membership-table-wrap">
                     <table class="membership-table">
                        <thead>
                           <tr>
                              <th>No.</th>
                              <th>Position</th>
                              <th>Employment Organisation</th>
                              <th>Date Start</th>
                              <th>Date End</th>
                              <th>Experience (Years)</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="item in selectedMember._empexp" :key="'exp-' + item.id">
                              <td>{{ item.sequence || '-' }}</td>
                              <td>{{ item.position || '-' }}</td>
                              <td>{{ item.emporg || '-' }}</td>
                              <td>{{ displayDate(item.empdatestart) }}</td>
                              <td>{{ displayDate(item.empdateend) }}</td>
                              <td>{{ item.totalexp || '-' }}</td>
                           </tr>
                           <tr v-if="!selectedMember._empexp || !selectedMember._empexp.length">
                              <td colspan="6" class="membership-empty">No record captured.</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <div class="membership-total-line">Total Experience: <strong>{{ employmentTotal(selectedMember) }}</strong></div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Present Employment Category</div>
                  <div class="membership-check-grid">
                     <div v-for="item in employmentCategories(selectedMember._empcat)" :key="item.label" class="membership-check-item" :class="{ active: item.checked }">
                        <v-icon small>{{ item.checked ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                        <span>{{ item.label }}<strong v-if="item.detail">: {{ item.detail }}</strong></span>
                     </div>
                  </div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Declaration</div>
                  <p class="membership-statement">
                     I, <strong>{{ selectedMember.fullname || '-' }}</strong>, desire to be admitted as a
                     <strong>{{ formattype(selectedMember.membertype) || '-' }} Member</strong> of the Malaysian Institute of Planners and declare that the information supplied herewith is true in every respect. I undertake to adhere to the Malaysian Institute of Planners Code of Professional Conduct, Regulations, and Charter & Bylaws throughout my membership of the Malaysian Institute of Planners.
                  </p>
                  <p class="membership-statement">
                     The Malaysian Institute of Planners Code of Professional Conduct, Regulations and Charter & Bylaws are subject to change and are available for members to view online or a hard copy is available on request.
                  </p>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Nomination</div>
                  <v-alert v-if="nominationResetMessage" dense outlined :type="nominationResetStatus" class="mx-4 mb-3">
                     {{ nominationResetMessage }}
                  </v-alert>
                  <div v-if="hasNominationRecord(selectedMember)" class="membership-card-grid">
                     <div class="membership-person-card">
                        <div class="membership-person-header">
                           <div class="membership-person-role">Proposer</div>
                           <v-btn
                              v-if="hasNominationPerson(selectedMember, 'proposer')"
                              x-small
                              outlined
                              color="error"
                              :loading="resettingNomination === 'proposer'"
                              @click="resetNomination('proposer')"
                           >
                              Reset Proposer
                           </v-btn>
                        </div>
                        <div class="membership-person-name">{{ nominationPerson(selectedMember, 'proposer').fullname || '-' }}</div>
                        <div class="membership-field compact"><span>Member ID</span><strong>{{ nominationPerson(selectedMember, 'proposer').memberid || '-' }}</strong></div>
                        <div class="membership-field compact"><span>LPBM No.</span><strong>{{ nominationPerson(selectedMember, 'proposer').lpbmno || '-' }}</strong></div>
                        <div class="membership-field compact"><span>Email</span><strong>{{ nominationPerson(selectedMember, 'proposer').contactemail || '-' }}</strong></div>
                        <div class="membership-field compact"><span>Mobile</span><strong>{{ nominationPerson(selectedMember, 'proposer').contactmobile || '-' }}</strong></div>
                        <div class="membership-field compact"><span>Sent</span><strong>{{ displayDate(nominationPerson(selectedMember, 'proposer').datesent) }}</strong></div>
                        <div class="membership-field compact"><span>Responded</span><strong>{{ displayDate(nominationPerson(selectedMember, 'proposer').dateresponse) }}</strong></div>
                     </div>
                     <div class="membership-person-card">
                        <div class="membership-person-header">
                           <div class="membership-person-role">Seconder</div>
                           <v-btn
                              v-if="hasNominationPerson(selectedMember, 'seconder')"
                              x-small
                              outlined
                              color="error"
                              :loading="resettingNomination === 'seconder'"
                              @click="resetNomination('seconder')"
                           >
                              Reset Seconder
                           </v-btn>
                        </div>
                        <div class="membership-person-name">{{ nominationPerson(selectedMember, 'seconder').fullname || '-' }}</div>
                        <div class="membership-field compact"><span>Member ID</span><strong>{{ nominationPerson(selectedMember, 'seconder').memberid || '-' }}</strong></div>
                        <div class="membership-field compact"><span>LPBM No.</span><strong>{{ nominationPerson(selectedMember, 'seconder').lpbmno || '-' }}</strong></div>
                        <div class="membership-field compact"><span>Email</span><strong>{{ nominationPerson(selectedMember, 'seconder').contactemail || '-' }}</strong></div>
                        <div class="membership-field compact"><span>Mobile</span><strong>{{ nominationPerson(selectedMember, 'seconder').contactmobile || '-' }}</strong></div>
                        <div class="membership-field compact"><span>Sent</span><strong>{{ displayDate(nominationPerson(selectedMember, 'seconder').datesent) }}</strong></div>
                        <div class="membership-field compact"><span>Responded</span><strong>{{ displayDate(nominationPerson(selectedMember, 'seconder').dateresponse) }}</strong></div>
                     </div>
                  </div>
                  <div v-else class="membership-empty">No nomination record captured.</div>
               </section>

               <section class="membership-section">
                  <div class="membership-section-title">Payment History</div>
                  <div class="membership-table-wrap">
                     <table class="membership-table">
                        <thead>
                           <tr>
                              <th>Payment For</th>
                              <th>Method</th>
                              <th>Payment Date</th>
                              <th>Year</th>
                              <th>Amount</th>
                              <th>Reference</th>
                              <th>Status</th>
                              <th>Receipt No.</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="item in selectedMember._payments" :key="'pay-' + item.tabletype + '-' + item.id">
                              <td>{{ memberPaymentType(item) }}</td>
                              <td>{{ memberPaymentMethod(item.paymentmethod) }}</td>
                              <td>{{ displayDate(item.paymentdate) }}</td>
                              <td>{{ item.payyear || '-' }}</td>
                              <td>RM {{ Number(item.amount || 0).toFixed(2) }}</td>
                              <td>{{ item.trxnid || '-' }}</td>
                              <td>{{ memberPaymentStatus(item.trxnstatus) }}</td>
                              <td>{{ item.receipt_no || '-' }}</td>
                           </tr>
                           <tr v-if="!selectedMember._payments || !selectedMember._payments.length">
                              <td colspan="8" class="membership-empty">No payment record captured.</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </section>
            </div>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlgresetpwd" width="460" persistent>
         <v-card>
            <v-card-title>Reset Password</v-card-title>
            <v-card-text>
               Reset password for this user?
               <div class="mt-3 font-weight-medium">{{ resetMember ? resetMember.fullname : '' }}</div>
               <v-alert dense outlined type="info" class="mt-4">
                  Password will be reset to the system default password.
               </v-alert>
               <v-alert v-if="resetMessage" dense outlined :type="resetStatus">
                  {{ resetMessage }}
               </v-alert>
            </v-card-text>
            <v-card-actions class="pb-4 px-6">
               <v-spacer></v-spacer>
               <v-btn text @click="closeResetPassword">Close</v-btn>
               <v-btn color="primary" :loading="resettingPassword" @click="resetPassword">
                  Reset
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlgexpiredreminder" width="520" persistent>
         <v-card>
            <v-card-title>Send Expired Membership Reminder</v-card-title>
            <v-card-text>
               Send renewal reminder email to this member?
               <div class="mt-3 font-weight-medium">{{ reminderMember ? reminderMember.fullname : '' }}</div>
               <div class="caption grey--text text--darken-1">{{ reminderMember ? (reminderMember.contactemail || '-') : '' }}</div>
               <v-alert dense outlined type="info" class="mt-4">
                  This reminder is intended for members whose membership validity date has expired.
               </v-alert>
               <v-alert v-if="reminderMessage" dense outlined :type="reminderStatus">
                  {{ reminderMessage }}
               </v-alert>
            </v-card-text>
            <v-card-actions class="pb-4 px-6">
               <v-spacer></v-spacer>
               <v-btn text @click="closeExpiredReminder">Close</v-btn>
               <v-btn color="primary" :loading="sendingReminder" @click="sendExpiredReminder">
                  Send Reminder
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlgbulkreminder" width="560" persistent>
         <v-card>
            <v-card-title>Send Renewal Reminders</v-card-title>
            <v-card-text>
               <div v-if="loadingBulkReminder" class="py-6 text-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <div class="caption mt-3">Checking eligible members...</div>
               </div>
               <template v-else>
                  <v-alert dense outlined type="info">
                     Only eligible members with outstanding annual fees will receive an email. Members already notified for the same renewal year will be skipped.
                  </v-alert>
                  <v-simple-table dense v-if="bulkReminderPreview">
                     <tbody>
                        <tr><td>Renewal year</td><td class="text-right font-weight-bold">{{ bulkReminderPreview.subscription_year }}</td></tr>
                        <tr><td>Ready to send</td><td class="text-right font-weight-bold">{{ bulkReminderPreview.eligible }}</td></tr>
                        <tr><td>Already sent</td><td class="text-right">{{ bulkReminderPreview.already_sent }}</td></tr>
                        <tr><td>Missing email</td><td class="text-right">{{ bulkReminderPreview.missing_email }}</td></tr>
                        <tr><td>Invalid membership record</td><td class="text-right">{{ bulkReminderPreview.invalid_record }}</td></tr>
                     </tbody>
                  </v-simple-table>
                  <v-alert v-if="bulkReminderMessage" dense outlined class="mt-4" :type="bulkReminderStatus">
                     {{ bulkReminderMessage }}
                  </v-alert>
               </template>
            </v-card-text>
            <v-card-actions class="pb-4 px-6">
               <v-spacer></v-spacer>
               <v-btn text :disabled="sendingBulkReminder" @click="closeBulkReminder">Close</v-btn>
               <v-btn
                  color="primary"
                  :loading="sendingBulkReminder"
                  :disabled="loadingBulkReminder || !bulkReminderPreview || bulkReminderPreview.eligible < 1"
                  @click="sendBulkRenewalReminders"
               >
                  <v-icon left small>mdi-send</v-icon>
                  Send {{ bulkReminderPreview ? bulkReminderPreview.eligible : 0 }} Email(s)
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlgconfirm" width="400" persistent dark>
         <v-card>
            <v-card-title class="title"><span class="text-white">Confirm you want to delete this?</span></v-card-title>
            <v-card-text>
               <v-row dense>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>No.</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ (todelete) ? todelete.no : '' }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Full Name</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ (todelete) ? todelete.fullname : '' }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Member ID</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ (todelete) ? todelete.memberid : '' }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Email</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ (todelete) ? todelete.contactemail : '' }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Mobile</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ (todelete) ? todelete.contactmobile : '' }}</small>
                  </v-col>
               </v-row>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" dark @click="deleteItem(todelete)">
                  Yes
               </v-btn>
               <v-btn color="primary" dark @click="closeConfirm">
                  No
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlglisting" fullscreen hide-overlay transition="dialog-bottom-transition">
         <v-card>
            <v-toolbar dark color="grey darken-4">
               <v-btn icon dark @click="dlglisting = false">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
               <v-toolbar-title>View List Membership</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn color="primary" dark small @click="downloadExcel">
                  <v-icon left small>mdi-microsoft-excel</v-icon>
                  Download Excel
               </v-btn>
            </v-toolbar>

            <div class="pa-4">
               <v-data-table
                  :headers="listingHeaders"
                  :items="filteredItems"
                  class="border"
                  dense
                  disable-pagination
                  hide-default-footer
               >
                  <template v-slot:[`item.memberstatus`]="{ item }">
                     {{ formatstatus(item.memberstatus) }}
                  </template>
                  <template v-slot:[`item.membertype`]="{ item }">
                     {{ formattype(item.membertype) }}
                  </template>
                  <template v-slot:[`item.dob`]="{ item }">
                     {{ displayDate(item.dob) }}
                  </template>
               </v-data-table>
            </div>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
import DialogMemberEdit from '../Dialogs/DialogMemberEdit.vue';
import DialogMemberNew from '../Dialogs/DialogMemberNew.vue';
const axios = require('axios')

export default {
   name: "TableAdmMembership",
   components: {
      DialogMemberEdit,
      DialogMemberNew,
   },
   data: () => ({
      user: Object,
      search: '',
      searchfield: 'all',
      searchfields: [
         { text: 'All Fields', value: 'all' },
         { text: 'Name', value: 'fullname' },
         { text: 'Member ID', value: 'memberid' },
         { text: 'IC / Passport', value: 'icpassport' },
         { text: 'Email', value: 'contactemail' },
         { text: 'Mobile No.', value: 'contactmobile' },
      ],
      filtertype: null,
      optfiltertypes: [
         { membertype: "ASC", title: "Associate Member" },
         { membertype: "STU", title: "Student Member" },
         { membertype: "GRA", title: "Graduate Member" },
         { membertype: "COR", title: "Corporate Member" },
         { membertype: "FEL", title: "Fellow Member" },
         { membertype: "HON", title: "Honorary Member" },
         { membertype: "PAT", title: "Patron" },
      ],
      optfilterstatus: [
         { memberstatus: 0, title: "Applying" },
         { memberstatus: 1, title: "Pending Approval" },
         { memberstatus: 2, title: "Pending Payment" },
         { memberstatus: 3, title: "Active" },
         { memberstatus: 4, title: "Suspended" },
         { memberstatus: 5, title: "Retired" },
         { memberstatus: 6, title: "Deceased" },
         { memberstatus: 7, title: "Struck-Off" },
         { memberstatus: 8, title: "Active - Not Good Standing" },
         { memberstatus: 9, title: "Incomplete Application" },
         { memberstatus: 10, title: "Rejected Application" },
      ],
      filterstatus: 3,
      listitems: [],
      dlgconfirm: false,
      dlgview: false,
      dlgresetpwd: false,
      dlgexpiredreminder: false,
      dlgbulkreminder: false,
      dlglisting: false,
      editedIndex: -1,
      editedItem: Object,
      todelete: Object,
      defaultItem: Object,
      selectedMember: null,
      viewLoading: false,
      resetMember: null,
      resettingPassword: false,
      resetMessage: '',
      resetStatus: 'success',
      resettingNomination: '',
      nominationResetMessage: '',
      nominationResetStatus: 'success',
      reminderMember: null,
      sendingReminder: false,
      reminderMessage: '',
      reminderStatus: 'success',
      loadingBulkReminder: false,
      sendingBulkReminder: false,
      bulkReminderPreview: null,
      bulkReminderMessage: '',
      bulkReminderStatus: 'success',
   }),

   computed: {
      searchLabel() {
         const selected = this.searchfields.find((item) => item.value === this.searchfield)
         return selected ? `Search ${selected.text}` : 'Search'
      },

      filteredItems() {
         const keyword = this.normalizeSearchValue(this.search)
         const compactKeyword = this.compactSearchValue(this.search)
         const searchTargets = this.searchfield === 'all'
            ? ['fullname', 'memberid', 'icpassport', 'contactemail', 'contactmobile']
            : [this.searchfield]

         return this.listitems
            .filter((item) => {
               const matchesType = !this.filtertype || item.membertype === this.filtertype
               const matchesStatus = this.filterstatus === null
                  || this.filterstatus === undefined
                  || String(item.memberstatus) === String(this.filterstatus)
               const matchesSearch = !keyword || searchTargets.some((field) => {
                  const value = item[field] || ''
                  const normalizedValue = this.normalizeSearchValue(value)
                  const compactValue = this.compactSearchValue(value)

                  return normalizedValue.includes(keyword)
                     || (!!compactKeyword && compactValue.includes(compactKeyword))
               })
               return matchesType && matchesStatus && matchesSearch
            })
            .map((item, index) => ({ 
               ...item, 
               no: index + 1,
               age: this.memberAge(item.dob)
            }))
      },

      headers()  {
         return [
            {
               text: "No.",
               align: "start",
               sortable: true,
               width: "70",
               value: "no",
            },
            {
               text: "Full Name",
               sortable: false,
               value: "fullname"
            },
            {
               text: "IC / Passport No.",
               sortable: false,
               value: "icpassport"
            },
            {
               text: "Member ID",
               sortable: false,
               value: "memberid"
            },
            {
               text: "Mobile",
               sortable: false,
               value: "contactmobile"
            },
            {
               text: "Email",
               sortable: false,
               value: "contactemail"
            },
            {
               text: "Member Type",
               sortable: false,
               value: "membertype",
            },
            {
               text: "Status",
               sortable: false,
               value: "memberstatus",
            },
            {
               text: "Outstanding",
               sortable: false,
               value: "outstanding_fee",
               width: "180",
            },
            { text: "Actions", value: "actions", sortable: false, width: "230" }
         ]
      },

      listingHeaders() {
         return [
            { text: 'Name', value: 'fullname', sortable: true },
            { text: 'IC / Passport', value: 'icpassport', sortable: true },
            { text: 'Member ID', value: 'memberid', sortable: true },
            { text: 'LPBM', value: 'lpbmno', sortable: true },
            { text: 'Email', value: 'contactemail', sortable: true },
            { text: 'Mobile No.', value: 'contactmobile', sortable: true },
            { text: 'Date of Birth', value: 'dob', sortable: true },
            { text: 'Age', value: 'age', sortable: true },
            { text: 'Gender', value: 'gender', sortable: true },
            { text: 'Race', value: 'race', sortable: true },
            { text: 'Religion', value: 'religion', sortable: true },
            { text: 'Member Type', value: 'membertype', sortable: true },
            { text: 'Status', value: 'memberstatus', sortable: true },
         ]
      },
   },

   watch: {

   },

   mounted() {
      this.user = this.$page.user;
      this.initialize();
   },

   methods: {
      normalizeSearchValue(value) {
         return (value || '').toString().trim().toLowerCase()
      },

      compactSearchValue(value) {
         return this.normalizeSearchValue(value).replace(/[^a-z0-9]/g, '')
      },

      onMembershipUpdated() {
         this.initialize()
      },

      onMembershipApproved() {
         this.initialize()
      },

      hasOutstandingFee(item) {
         return Number(item && item.outstanding_year_count || 0) > 0
      },

      formatMoney(value) {
         var amount = Number(value || 0)
         return 'RM ' + amount.toFixed(2)
      },

      outstandingText(item) {
         if (!item) {
            return '-'
         }
         if (item.outstanding_status === 'not_applicable') {
            return 'No annual fee'
         }
         if (this.hasOutstandingFee(item)) {
            return 'Years: ' + (item.outstanding_label || '-')
         }
         if (item.outstanding_status === 'missing_validity') {
            return 'No valid date recorded'
         }
         if (item.outstanding_status === 'invalid_validity') {
            return 'Invalid valid date'
         }
         return 'No overdue fee'
      },

      initialize() {
         this.$nextTick(() => {
            this.uploadfile = null
            axios.get('/member/list')
            .then((resp) => {
               if (resp.data) {
                  var rtn = resp.data
                  if (rtn.status === 'OK') {
                     this.listitems = Array.isArray(rtn.data) ? rtn.data : []
                  } else {
                     console.log(rtn.status + ': ' + rtn.error)
                  }
               }
            })
            .catch((error) => {
               console.log(error)
               this.listitems = []
            })
         })
      },

      formatstatuscolor(e) {
         const status = Number(e)
         if (status === 0) {
            return 'blue darken-3'
         }
         if (status === 1) {
            return 'yellow darken-3'
         }
         if (status === 2) {
            return 'red darken-3'
         }
         if (status === 3) {
            return 'green darken-3'
         }
         if (status === 4) {
            return 'red darken-3'
         }
         if (status === 5) {
            return 'grey darken-3'
         }
         if (status === 6) {
            return 'grey darken-3'
         }
         if (status === 7) {
            return 'red darken-4'
         }
         if (status === 8) {
            return 'orange darken-3'
         }
         if (status === 9) {
            return 'purple darken-2'
         }
         if (status === 10) {
            return 'red darken-4'
         }
         return 'grey darken-1'
      },

      formatstatus(e) {
         const status = Number(e)
         if (status === 0) {
            return 'Applying'
         }
         if (status === 1) {
            return 'Pending Approval'
         }
         if (status === 2) {
            return 'Pending Payment'
         }
         if (status === 3) {
            return 'Active'
         }
         if (status === 4) {
            return 'Suspended'
         }
         if (status === 5) {
            return 'Retired'
         }
         if (status === 6) {
            return 'Deceased'
         }
         if (status === 7) {
            return 'Struck-Off'
         }
         if (status === 8) {
            return 'Active - Not Good Standing'
         }
         if (status === 9) {
            return 'Incomplete Application'
         }
         if (status === 10) {
            return 'Rejected Application'
         }
         return '-'
      },


      formattype(e) {
         if (e === 'GRA') {
            return 'Graduate'
         }
         if (e === 'STU') {
            return 'Student'
         }
         if (e === 'COR') {
            return 'Corporate'
         }
         if (e === 'HON') {
            return 'Honorary'
         }
         if (e === 'PAT') {
            return 'Patron'
         }
         if (e === 'FEL') {
            return 'Fellow'
         }
         if (e === 'ASC') {
            return 'Associate'
         }
         return e || '-'
      },

      viewListing() {
         window.location.href = '/admin/membership/listing'
      },

      newItem() {
         this.$refs.dlgnew.show()
      },

      editItem(pItem) {
         this.$refs.dlgedit.setid(pItem.id)
      },

      loadMemberForView(pItem) {
         if (!pItem || !pItem.id) {
            return Promise.resolve(pItem)
         }

         this.viewLoading = true
         return axios.get('/admin/member/' + pItem.id)
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK' && resp.data.data) {
               return resp.data.data
            }

            return pItem
         })
         .catch((error) => {
            console.error('Unable to load full membership record.', error)
            return pItem
         })
         .finally(() => {
            this.viewLoading = false
         })
      },

      dataFromResponse(resp) {
         var payload = resp ? resp.data : null

         if (typeof payload === 'string') {
            try {
               payload = JSON.parse(payload)
            } catch (error) {
               payload = null
            }
         }

         if (payload && payload.status === 'OK') {
            return payload.data
         }

         return null
      },

      listFromResponse(resp) {
         var data = this.dataFromResponse(resp)

         if (Array.isArray(data)) {
            return data
         }

         if (data) {
            return [data]
         }

         return []
      },

      loadMemberApplicationRecord(pItem) {
         return this.loadMemberForView(pItem).then((member) => {
            if (!member) {
               return member
            }

            var userid = member.userid || (pItem ? pItem.userid : null)
            if (!userid) {
               return member
            }

            return Promise.all([
               axios.get('/member/qualedu/list/' + userid).catch(() => null),
               axios.get('/member/qualpro/list/' + userid).catch(() => null),
               axios.get('/member/qualstu/list/' + userid).catch(() => null),
               axios.get('/member/empexp/list/' + userid).catch(() => null),
               axios.get('/member/empcat/list/' + userid).catch(() => null),
               axios.get('/member/decl/getackproposer/' + userid).catch(() => null),
               axios.get('/member/decl/getackseconder/' + userid).catch(() => null),
               axios.post('/admin/member/payments/list', { userid: userid }).catch(() => null)
            ])
            .then((responses) => {
               member._qualedu = this.listFromResponse(responses[0])
               member._qualpro = this.listFromResponse(responses[1])
               member._qualstu = this.listFromResponse(responses[2])
               member._empexp = this.listFromResponse(responses[3])
               var empcatData = this.dataFromResponse(responses[4])
               member._empcat = Array.isArray(empcatData) ? (empcatData[0] || {}) : (empcatData || {})
               member._declProposer = this.listFromResponse(responses[5])
               member._declSeconder = this.listFromResponse(responses[6])
               member._payments = this.listFromResponse(responses[7])
               return member
            })
         })
      },

      viewItem(pItem) {
         this.selectedMember = null
         this.dlgview = true
         this.loadMemberApplicationRecord(pItem).then((member) => {
            this.selectedMember = member
         })
      },

      printItem(pItem) {
         this.loadMemberApplicationRecord(pItem).then((member) => {
            this.selectedMember = member
            this.$nextTick(() => {
               this.printSelectedMember()
            })
         })
      },

      printSelectedMember() {
         if (!this.selectedMember) {
            return
         }

         var html = this.membershipPrintHtml(this.selectedMember)
         var win = window.open('', '_blank', 'width=1000,height=800')
         if (!win) {
            alert('Please allow pop-ups to print membership.')
            return
         }

         win.document.open()
         win.document.write(html)
         win.document.close()
         setTimeout(() => win.print(), 500)
      },

      membershipPrintHtml(member) {
         var esc = this.escapeHtml
         var row = (label, value) => '<div class="field"><span>' + esc(label) + '</span><strong>' + esc(value || '-') + '</strong></div>'
         var section = (title, content) => '<div class="section"><div class="section-title">' + esc(title) + '</div>' + content + '</div>'
         var empty = '<div class="empty-record">No record captured.</div>'
         var docUrl = (item) => {
            if (!item || !item.document || !item.documentpath || item.documentpath === 'renewal-ref') {
               return null
            }
            var path = String(item.documentpath).replace(/^\/+|\/+$/g, '')
            var document = String(item.document).replace(/^\/+/g, '')
            return this.absoluteAsset('/' + path + '/' + encodeURIComponent(document).replace(/%2F/g, '/'))
         }
         var docLink = (item) => {
            var url = docUrl(item)
            if (!url) {
               return esc(item && item.document ? item.document : '-')
            }
            return '<a href="' + esc(url) + '">' + esc(item.document) + '</a>'
         }
         var table = (headers, rows) => {
            var head = '<tr>' + headers.map((header) => '<th>' + esc(header) + '</th>').join('') + '</tr>'
            var body = rows.length
               ? rows.map((cols) => '<tr>' + cols.map((col) => '<td>' + (col || '-') + '</td>').join('') + '</tr>').join('')
               : '<tr><td colspan="' + headers.length + '">' + empty + '</td></tr>'
            return '<table><thead>' + head + '</thead><tbody>' + body + '</tbody></table>'
         }
         var logo = this.absoluteAsset('/images/miplogo-300x300.png')
         var photo = this.absoluteAsset(this.memberImage(member))
         var salutation = member.salutation ? row('Salutation', member.salutation) : ''
         var educationRows = (member._qualedu || []).map((item) => [
            esc(item.sequence || '-'),
            esc(item.qualification || '-'),
            esc(item.university || '-'),
            esc(item.country || '-'),
            esc(this.displayDate(item.datecommence)),
            esc(this.displayDate(item.datequalification)),
            docLink(item)
         ])
         var professionalRows = (member._qualpro || []).map((item) => [
            esc(item.sequence || '-'),
            esc(item.qualname || '-'),
            esc(item.qualbodyinstname || '-'),
            esc(this.displayDate(item.datereceived)),
            esc(this.displayDate(item.datevalid)),
            docLink(item)
         ])
         var studentRows = (member._qualstu || []).map((item) => [
            esc(item.sequence || '-'),
            esc(item.course || '-'),
            esc(item.instname || '-'),
            esc(this.displayDate(item.datecommence)),
            esc(this.displayDate(item.datecomplete)),
            docLink(item)
         ])
         var employmentRows = (member._empexp || []).map((item) => [
            esc(item.sequence || '-'),
            esc(item.position || '-'),
            esc(item.emporg || '-'),
            esc(this.displayDate(item.empdatestart)),
            esc(this.displayDate(item.empdateend)),
            esc(item.totalexp || '-')
         ])
         var paymentRows = (member._payments || []).map((item) => {
            var receiptUrl = item.tabletype === 'renewals'
               ? this.absoluteAsset('/member/payment/renewal/receipt/' + item.id)
               : this.absoluteAsset('/member/payment/receipt/' + item.id)
            var receipt = item.trxnstatus === '01'
               ? '<a href="' + esc(receiptUrl) + '">' + esc(item.receipt_no || 'View receipt') + '</a>'
               : esc(item.receipt_no || '-')
            return [
               esc(this.memberPaymentType(item)),
               esc(this.memberPaymentMethod(item.paymentmethod)),
               esc(this.displayDate(item.paymentdate)),
               esc(item.payyear || '-'),
               esc('RM ' + Number(item.amount || 0).toFixed(2)),
               esc(item.trxnid || '-'),
               esc(this.memberPaymentStatus(item.trxnstatus)),
               receipt
            ]
         })
         var checkItem = (label, checked, detail) => {
            return '<div class="check-item"><span class="box ' + (checked ? 'checked' : '') + '">' + (checked ? '&#10003;' : '') + '</span><span>' + esc(label) + (detail ? ': ' + esc(detail) : '') + '</span></div>'
         }
         var contactPrefs = '<div class="check-grid">' +
            checkItem('Home Address', this.isChecked(member.prefercontacthome)) +
            checkItem('Work Address', this.isChecked(member.prefercontactwork)) +
            checkItem('Email', this.isChecked(member.prefercontactemail)) +
            '</div>'
         var empCatHtml = '<div class="check-grid">' + this.employmentCategories(member._empcat).map((item) => {
            return checkItem(item.label, item.checked, item.detail)
         }).join('') + '</div>'
         var nominationBlock = (title, person) => {
            var nomRow = (label, value) => '<div class="nom-field"><span>' + esc(label) + '</span><strong>' + esc(value || '-') + '</strong></div>'
            return '<div class="nom-card"><div class="nom-role">' + esc(title) + '</div>' +
               nomRow('Name', person.fullname) +
               nomRow('Member ID', person.memberid) +
               nomRow('LPBM No.', person.lpbmno) +
               nomRow('Email', person.contactemail) +
               nomRow('Mobile', person.contactmobile) +
               nomRow('Sent', this.displayDate(person.datesent)) +
               nomRow('Responded', this.displayDate(person.dateresponse)) +
               '</div>'
         }
         var nominationHtml = this.hasNominationRecord(member)
            ? '<div class="nom-grid">' + nominationBlock('Proposer', this.nominationPerson(member, 'proposer')) + nominationBlock('Seconder', this.nominationPerson(member, 'seconder')) + '</div>'
            : empty
         var corporateUpgrade = ''
         if (member.applcorpstatus || member.applcorp_course_date || member.applcorp_interview_date || member.applcorp_exam_date || member.applcorp_notes || member.applcorp_supportdoc) {
            corporateUpgrade = section('Corporate Upgrade Record',
               row('Upgrade Status', member.applcorpstatus) +
               row('Course Date', this.displayDate(member.applcorp_course_date)) +
               row('Interview Date', this.displayDate(member.applcorp_interview_date)) +
               row('Exam Date', this.displayDate(member.applcorp_exam_date)) +
               row('Notes', member.applcorp_notes) +
               row('Support Document', member.applcorp_supportdoc)
            )
         }

         return '<!doctype html><html><head><title>Membership - ' + esc(member.fullname || '') + '</title>' +
            '<style>' +
            'body{font-family:Arial,sans-serif;color:#102033;margin:0;padding:0;font-size:12px;background:#fff}' +
            '.brand{background:linear-gradient(120deg,#07867f,#1f55d5);color:#fff;padding:22px 28px;display:flex;align-items:center;justify-content:space-between}' +
            '.brand-main{display:flex;align-items:center;gap:16px}.brand-logo{width:72px;height:72px;border-radius:50%;background:#fff;padding:8px;object-fit:contain}' +
            '.brand-kicker{text-transform:uppercase;letter-spacing:1.8px;font-size:10px;font-weight:700;opacity:.85}.brand-title{font-size:22px;font-weight:800;margin-top:4px}.brand-sub{font-size:12px;opacity:.9;margin-top:4px}' +
            '.brand-card{background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.42);border-radius:8px;padding:12px 14px;min-width:220px}.brand-card-label{display:block;text-transform:uppercase;font-size:10px;font-weight:700;letter-spacing:1px;opacity:.85;margin-bottom:10px}' +
            '.chips{display:flex;gap:8px;flex-wrap:wrap}.chip{border-radius:999px;font-size:10px;font-weight:800;line-height:1;padding:7px 11px}.chip-type{background:#e8f3ff;color:#155ec2}.chip-active{background:#dff7e7;color:#16833a}' +
            '.wrap{padding:22px 28px}' +
            '.profile{border:1px solid #dbe4f0;border-radius:8px;padding:16px;margin-bottom:18px;display:flex;align-items:center;gap:18px}' +
            '.profile-photo{width:110px;height:130px;object-fit:cover;border:1px solid #dbe4f0;border-radius:6px;background:#f5f8fb}' +
            'h1{font-size:20px;margin:0 0 8px;color:#102033}.meta{display:flex;gap:12px;flex-wrap:wrap;color:#476078;font-weight:700}' +
            '.section{border-top:1px solid #dbe4f0;padding:16px 0}' +
            '.section-title{font-size:11px;text-transform:uppercase;letter-spacing:1.4px;color:#476078;font-weight:700;margin-bottom:14px}' +
            '.grid{display:grid;grid-template-columns:1fr 280px;gap:20px}' +
            '.field{display:grid;grid-template-columns:260px 1fr;gap:12px;min-height:24px;align-items:start}' +
            '.field span{font-weight:700;color:#476078}.field strong{font-weight:400;color:#102033;overflow-wrap:anywhere}' +
            '.statement{line-height:1.7;color:#102033}.empty-record{padding:18px;text-align:center;color:#6b7c8f;background:#f7fafc;border-radius:6px}' +
            '.check-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}.check-item{align-items:center;border:1px solid #dbe4f0;border-radius:6px;display:flex;gap:10px;padding:10px;color:#102033}.box{align-items:center;border:1px solid #8aa0b7;display:inline-flex;height:14px;justify-content:center;width:14px}.checked{background:#16833a;border-color:#16833a;color:#fff}.total-line{text-align:right;font-weight:700;margin-top:8px}.nom-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}.nom-card{border:1px solid #dbe4f0;border-radius:8px;padding:12px}.nom-role{text-transform:uppercase;letter-spacing:1px;font-size:10px;font-weight:800;color:#476078;margin-bottom:8px}.nom-field{display:grid;grid-template-columns:95px minmax(0,1fr);gap:10px;margin-bottom:8px}.nom-field span{color:#476078;font-weight:700}.nom-field strong{color:#102033;font-weight:400;line-height:1.45;overflow-wrap:break-word;word-break:normal}' +
            'table{width:100%;border-collapse:collapse;font-size:11px}th{background:#eef4fb;color:#39506a;text-align:left;text-transform:uppercase;letter-spacing:.6px;font-size:10px}th,td{border:1px solid #dbe4f0;padding:8px;vertical-align:top}td{color:#102033}a{color:#155ec2;text-decoration:none}' +
            '@media print{.brand{background:linear-gradient(120deg,#07867f,#1f55d5)!important;color:#fff!important;-webkit-print-color-adjust:exact;print-color-adjust:exact}.profile{break-inside:avoid}.section{break-inside:avoid}}' +
            '</style></head><body>' +
            '<div class="brand"><div class="brand-main"><img class="brand-logo" src="' + esc(logo) + '"><div><div class="brand-kicker">Malaysian Institute of Planners</div><div class="brand-title">MIP Online Membership System</div><div class="brand-sub">Official Membership Profile Record</div></div></div><div class="brand-card"><span class="brand-card-label">Membership Standing</span><div class="chips"><span class="chip chip-type">' + esc(this.formattype(member.membertype) || '-') + '</span><span class="chip chip-active">' + esc(this.formatstatus(member.memberstatus) || '-') + '</span></div></div></div>' +
            '<div class="wrap">' +
            '<div class="profile"><img class="profile-photo" src="' + esc(photo) + '"><div><h1>' + esc(member.fullname || '-') + '</h1><div class="meta"><span>Member ID: ' + esc(member.memberid || 'Not assigned') + '</span><span>IC / Passport: ' + esc(member.icpassport || '-') + '</span><span>Member Type: ' + esc(this.formattype(member.membertype) || '-') + '</span></div></div></div>' +
            section('General Membership Information',
            row('Member ID', member.memberid) +
            row('LPBM No.', this.lpbmNo(member)) +
            row('Member Type', this.formattype(member.membertype)) +
            row('Membership Status', this.formatstatus(member.memberstatus)) +
            row('Date Applied', this.displayDate(member.dateapplied)) +
            row('Date Approved', this.displayDate(member.dateapproved)) +
            row('Date Payment (Registration)', this.displayDate(member.datepayment)) +
            row('Valid Until', this.displayDate(member.datevalid))
            ) +
            section('Personal Details',
            salutation +
            row('Full Name', member.fullname) +
            row('IC / Passport No.', member.icpassport) +
            row('Contact No.', member.contactmobile) +
            row('Email', member.contactemail) +
            row('Gender', member.gender) +
            row('Nationality', member.nationality) +
            row('Race', member.race) +
            row('Religion', member.religion) +
            row('Date of Birth', this.displayDate(member.dob)) +
            row('Age', this.memberAge(member.dob)) +
            row('Place of Birth', member.pob)
            ) +
            section('Home Address',
            row('Address', member.homestreet) +
            row('Postcode', member.homepostcode) +
            row('City', member.homecity) +
            row('District', member.homedistrict) +
            row('State', member.homestate) +
            row('Country', member.homecountry) +
            row('Phone', member.homephone)
            ) +
            section('Practice',
            row('Organization / Company / Practice', member.workcompany) +
            row('Job Title', member.workjobtitle) +
            row('Department', member.workdept) +
            row('Position / Grade', member.workposition) +
            row('Address', member.workstreet) +
            row('Postcode', member.workpostcode) +
            row('City', member.workcity) +
            row('District', member.workdistrict) +
            row('State', member.workstate) +
            row('Country', member.workcountry) +
            row('Phone', member.workphone) +
            row('Fax', member.workfax) +
            row('Email', member.workemail)
            ) +
            section('Preferred Contact Method', contactPrefs) +
            section('Education Qualification',
               table(['No.', 'Qualification', 'University', 'Country', 'Date Commenced', 'Date Qualified', 'Document'], educationRows)
            ) +
            section('Professional Qualification',
               table(['No.', 'Qualification / Membership', 'Qualifying Body / Institute', 'Date Received', 'Date Valid', 'Document'], professionalRows)
            ) +
            section('Student Qualification',
               table(['No.', 'Course of Study', 'Institution', 'Date Commenced', 'Date Completed', 'Document'], studentRows)
            ) +
            section('Employment Experience',
               table(['No.', 'Position', 'Employment Organisation', 'Date Start', 'Date End', 'Experience (Years)'], employmentRows) +
               '<div class="total-line">Total Experience: ' + esc(this.employmentTotal(member)) + '</div>'
            ) +
            section('Present Employment Category', empCatHtml) +
            section('Declaration',
               '<div class="statement">I, <strong>' + esc(member.fullname || '-') + '</strong>, desire to be admitted as a <strong>' + esc(this.formattype(member.membertype) || '-') + ' Member</strong> of the Malaysian Institute of Planners and declare that the information supplied herewith is true in every respect. I undertake to adhere to the Malaysian Institute of Planners Code of Professional Conduct, Regulations, and Charter & Bylaws throughout my membership of the Malaysian Institute of Planners.</div>'
            ) +
            section('Nomination', nominationHtml) +
            corporateUpgrade +
            section('Payment History',
               table(['Payment For', 'Method', 'Payment Date', 'Year', 'Amount', 'Reference', 'Status', 'Receipt'], paymentRows)
            ) +
            '</div></body></html>'
      },

      isChecked(value) {
         return value === true || value === 1 || value === '1' || value === 'Y' || value === 'Yes' || value === 'yes'
      },

      employmentCategories(category) {
         var item = category || {}
         return [
            { label: 'Private Sector Employee', checked: this.isChecked(item.ispvtsectoremp) },
            { label: 'State or Federal Public Services', checked: this.isChecked(item.isstatepublicsvc) },
            { label: 'Local Government', checked: this.isChecked(item.islocalgov) },
            { label: 'Self Employment', checked: this.isChecked(item.isselfemployed) },
            { label: 'Academic', checked: this.isChecked(item.isacademic) },
            { label: 'Retired', checked: this.isChecked(item.isretired) },
            { label: 'Unemployed', checked: this.isChecked(item.isunemployed) },
            { label: 'Other', checked: !!item.other, detail: item.other || '' }
         ]
      },

      employmentTotal(member) {
         var rows = member && member._empexp ? member._empexp : []
         var total = rows.reduce((sum, item) => sum + Number(item.totalexp || 0), 0)
         return total ? total.toFixed(2) : '0'
      },

      nominationPerson(member, type) {
         if (!member) return {}
         var list = type === 'proposer' ? member._declProposer : member._declSeconder
         return list && list.length ? list[0] : {}
      },

      hasNominationPerson(member, type) {
         var person = this.nominationPerson(member, type)
         return !!(person.fullname || person.memberid || person.proposerid || person.seconderid)
      },

      hasNominationRecord(member) {
         var proposer = this.nominationPerson(member, 'proposer')
         var seconder = this.nominationPerson(member, 'seconder')
         return !!(proposer.fullname || proposer.memberid || seconder.fullname || seconder.memberid)
      },

      resetNomination(type) {
         if (!this.selectedMember || !this.selectedMember.userid) {
            return
         }

         var label = type === 'proposer' ? 'proposer' : 'seconder'
         if (!confirm('Reset this ' + label + ' nomination record?')) {
            return
         }

         var endpoint = type === 'proposer'
            ? '/admin/decl/resetdeclproposer'
            : '/admin/decl/resetdeclseconder'

         this.resettingNomination = type
         this.nominationResetMessage = ''

         axios.post(endpoint, {
            userid: this.selectedMember.userid
         })
         .then((resp) => {
            var rtn = resp.data || {}
            if (rtn.status === 'OK') {
               this.nominationResetStatus = 'success'
               this.nominationResetMessage = rtn.message || 'Nomination record reset successfully.'
               return this.loadMemberApplicationRecord(this.selectedMember).then((member) => {
                  this.selectedMember = member
               })
            }

            this.nominationResetStatus = 'error'
            this.nominationResetMessage = rtn.error || 'Unable to reset nomination record.'
         })
         .catch(() => {
            this.nominationResetStatus = 'error'
            this.nominationResetMessage = 'Unable to reset nomination record.'
         })
         .finally(() => {
            this.resettingNomination = ''
         })
      },

      memberPaymentStatus(value) {
         if (value === '01') return 'Success'
         if (value === '00' || value === '02') return 'Pending'
         if (value === '03') return 'Rejected'
         return value || '-'
      },

      memberPaymentMethod(value) {
         if (value === 'TOYYIBPAY') return 'ToyyibPay'
         if (value === 'MANUAL') return 'Manual by Admin'
         if (value === 'MANUAL_RECEIPT') return 'Manual Receipt'
         return value || '-'
      },

      memberPaymentType(item) {
         if (!item) return '-'
         if (item.paymenttype === 'EFSF') return item.description || 'Entrance Fee + Subscription Fee'
         if (item.paymenttype === 'SF') return item.tabletype === 'renewals' ? 'Annual Renewal' : (item.description || 'Subscription Fee')
         if (item.paymenttype === 'EF') return 'Entrance Fee'
         return item.description || item.paymenttype || '-'
      },

      confirmResetPassword(pItem) {
         this.resetMember = pItem
         this.resetMessage = ''
         this.resetStatus = 'success'
         this.dlgresetpwd = true
      },

      closeResetPassword() {
         this.dlgresetpwd = false
         this.resetMember = null
         this.resetMessage = ''
      },

      resetPassword() {
         if (!this.resetMember) {
            return
         }

         this.resettingPassword = true
         this.resetMessage = ''

         axios.post('/admin/member/pwdreset', {
            userid: this.resetMember.userid
         })
         .then((resp) => {
            var rtn = resp.data
            if (rtn.status === 'OK') {
               this.resetStatus = 'success'
               this.resetMessage = rtn.message || 'Password successfully reset.'
            } else {
               this.resetStatus = 'error'
               this.resetMessage = rtn.error || 'Unable to reset password.'
            }
         })
         .catch(() => {
            this.resetStatus = 'error'
            this.resetMessage = 'Unable to reset password.'
         })
         .finally(() => {
            this.resettingPassword = false
         })
      },

      confirmExpiredReminder(pItem) {
         this.reminderMember = pItem
         this.reminderMessage = ''
         this.reminderStatus = 'success'
         this.dlgexpiredreminder = true
      },

      closeExpiredReminder() {
         this.dlgexpiredreminder = false
         this.reminderMember = null
         this.reminderMessage = ''
      },

      sendExpiredReminder() {
         if (!this.reminderMember) {
            return
         }

         this.sendingReminder = true
         this.reminderMessage = ''

         axios.post('/admin/member/email/expired-reminder', {
            userid: this.reminderMember.userid
         })
         .then((resp) => {
            var rtn = resp.data
            if (rtn.status === 'OK') {
               this.reminderStatus = 'success'
               this.reminderMessage = rtn.message || 'Expired membership reminder sent.'
            } else {
               this.reminderStatus = 'error'
               this.reminderMessage = rtn.error || 'Unable to send reminder.'
            }
         })
         .catch((error) => {
            this.reminderStatus = 'error'
            var response = error && error.response
            var data = response && response.data
            this.reminderMessage = (data && (data.error || data.message))
               || (response ? ('Unable to send reminder. Server returned ' + response.status + '.') : 'Unable to send reminder.')
         })
         .finally(() => {
            this.sendingReminder = false
         })
      },

      openBulkReminder() {
         this.dlgbulkreminder = true
         this.bulkReminderPreview = null
         this.bulkReminderMessage = ''
         this.bulkReminderStatus = 'success'
         this.loadingBulkReminder = true

         axios.get('/admin/member/email/renewal-reminders/preview')
         .then((resp) => {
            var rtn = resp.data
            if (rtn.status === 'OK') {
               this.bulkReminderPreview = rtn.data
            } else {
               this.bulkReminderStatus = 'error'
               this.bulkReminderMessage = rtn.error || 'Unable to check eligible members.'
            }
         })
         .catch(() => {
            this.bulkReminderStatus = 'error'
            this.bulkReminderMessage = 'Unable to check eligible members.'
         })
         .finally(() => {
            this.loadingBulkReminder = false
         })
      },

      closeBulkReminder() {
         this.dlgbulkreminder = false
         this.bulkReminderPreview = null
         this.bulkReminderMessage = ''
      },

      async sendBulkRenewalReminders() {
         if (!this.bulkReminderPreview || this.bulkReminderPreview.eligible < 1) {
            return
         }

         this.sendingBulkReminder = true
         this.bulkReminderMessage = ''

         var totalSent = 0
         var totalFailed = 0
         var batchCount = 0
         var failedUserids = []

         try {
            while (this.bulkReminderPreview.eligible > 0 && batchCount < 200) {
               var resp = await axios.post('/admin/member/email/renewal-reminders/send', {
                  limit: 25,
                  exclude_userids: failedUserids,
               })
               var rtn = resp.data
               var result = rtn.data || {}

               totalSent += Number(result.sent || 0)
               totalFailed += Number(result.failed || 0)
               failedUserids = failedUserids.concat(result.failed_userids || [])
               this.bulkReminderPreview = result
               batchCount++

               if (Number(result.sent || 0) === 0) {
                  break
               }
            }

            this.bulkReminderStatus = totalFailed > 0 ? 'warning' : 'success'
            this.bulkReminderMessage = totalSent + ' renewal reminder(s) sent.'
            if (totalFailed > 0) {
               this.bulkReminderMessage += ' ' + totalFailed + ' email attempt(s) failed and can be retried.'
            }
         } catch (error) {
            var response = error && error.response
            var data = response && response.data
            this.bulkReminderStatus = 'error'
            this.bulkReminderMessage = (data && (data.error || data.message)) || 'Unable to send renewal reminders.'
         } finally {
            this.sendingBulkReminder = false
         }
      },

      lpbmNo(member) {
         if (!member) {
            return '-'
         }

         return ((member.lpbmcode || '') + (member.lpbmno || '')) || '-'
      },

      displayDate(value) {
         if (!value) {
            return '-'
         }

         var parsed = new Date(value)
         if (isNaN(parsed.getTime())) {
            return value
         }

         var day = String(parsed.getDate()).padStart(2, '0')
         var month = String(parsed.getMonth() + 1).padStart(2, '0')
         return day + '/' + month + '/' + parsed.getFullYear()
      },

      memberAge(value) {
         if (!value) {
            return '-'
         }

         var dob = new Date(value)
         if (isNaN(dob.getTime())) {
            return '-'
         }

         var today = new Date()
         var age = today.getFullYear() - dob.getFullYear()
         var month = today.getMonth() - dob.getMonth()
         if (month < 0 || (month === 0 && today.getDate() < dob.getDate())) {
            age--
         }

         return age
      },

      memberImage(member) {
         if (member && member.photolink) {
            if (/^https?:\/\//i.test(member.photolink)) {
               return member.photolink
            }

            return '/' + String(member.photolink).replace(/^\/+/, '')
         }

         return '/images/miplogo-300x300.png'
      },

      absoluteAsset(path) {
         if (!path) {
            return ''
         }

         if (/^https?:\/\//i.test(path)) {
            return path
         }

         return window.location.origin + '/' + String(path).replace(/^\/+/, '')
      },

      escapeHtml(value) {
         return String(value === null || value === undefined ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
      },

      openCorporateInfo(pItem) {
         if (!pItem || !pItem.userid) {
            return
         }
         window.location.href = '/admin/member/upgrade-corporate/' + pItem.userid
      },

      downloadExcel() {
         const XLSX = require('xlsx')

         const rows = this.filteredItems.map(item => ({
            'Name': item.fullname || '',
            'IC / Passport': item.icpassport || '',
            'Member ID': item.memberid || '',
            'LPBM': this.lpbmNo(item),
            'Email': item.contactemail || '',
            'Mobile No.': item.contactmobile || '',
            'Date of Birth': this.displayDate(item.dob),
            'Age': this.memberAge(item.dob),
            'Gender': item.gender || '',
            'Race': item.race || '',
            'Religion': item.religion || '',
            'Member Type': this.formattype(item.membertype),
            'Status': this.formatstatus(item.memberstatus),
         }))

         const ws = XLSX.utils.json_to_sheet(rows)

         // Set column widths
         ws['!cols'] = [
            { wch: 30 }, // Name
            { wch: 18 }, // IC
            { wch: 14 }, // Member ID
            { wch: 12 }, // LPBM
            { wch: 30 }, // Email
            { wch: 14 }, // Mobile
            { wch: 14 }, // DOB
            { wch: 6  }, // Age
            { wch: 10 }, // Gender
            { wch: 10 }, // Race
            { wch: 10 }, // Religion
            { wch: 14 }, // Member Type
            { wch: 14 }, // Status
         ]

         const wb = XLSX.utils.book_new()
         XLSX.utils.book_append_sheet(wb, ws, 'Members')

         const filename = 'membership-list-' + new Date().toISOString().slice(0, 10) + '.xlsx'
         XLSX.writeFile(wb, filename)
      },

      // printItem(pItem) {
      //    const userid = pItem ? (pItem.userid || pItem.user_id || pItem.id) : null
      //    if (!userid) {
      //       return
      //    }
      //    window.open('/member/' + userid + '/print', '_blank')
      // },

      confirmDelete(pItem) {
         this.todelete = pItem
         this.dlgconfirm = true
      },

      closeConfirm() {
         this.dlgconfirm = false
         this.todelete = null
      },

      deleteItem(pItem) {
         if (!pItem) return

         axios.post('/admin/member/delete', { userid: pItem.userid })
         .then((resp) => {
            var rtn = resp.data
            if (rtn.status === 'OK') {
               this.closeConfirm()
               this.initialize()
            } else {
               alert(rtn.error || 'Unable to delete member.')
            }
         })
         .catch(() => {
            alert('Unable to delete member.')
         })
      },


   }
};
</script>

<style scoped>
.membership-view {
   background: #f4f7fb;
   color: #102033;
   min-height: calc(100vh - 64px);
}

.membership-view-toolbar {
   background: linear-gradient(90deg, #07867f 0%, #1f55d5 100%) !important;
}

.membership-brand-panel {
   align-items: center;
   background: linear-gradient(120deg, #07867f 0%, #1f55d5 100%);
   border-radius: 8px;
   color: #fff;
   display: flex;
   justify-content: space-between;
   margin-bottom: 16px;
   overflow: hidden;
   padding: 22px 26px;
}

.membership-brand-copy {
   align-items: center;
   display: flex;
   gap: 16px;
}

.membership-brand-logo {
   background: #fff;
   border-radius: 50%;
   height: 74px;
   object-fit: contain;
   padding: 8px;
   width: 74px;
}

.membership-brand-kicker,
.membership-view-kicker {
   font-size: 11px;
   font-weight: 700;
   letter-spacing: 1.8px;
   opacity: .85;
   text-transform: uppercase;
}

.membership-brand-title {
   font-size: 22px;
   font-weight: 800;
   margin-top: 4px;
}

.membership-brand-subtitle {
   font-size: 13px;
   opacity: .9;
}

.membership-brand-status {
   background: rgba(255, 255, 255, .12);
   border: 1px solid rgba(255, 255, 255, .38);
   border-radius: 8px;
   min-width: 230px;
   padding: 14px 16px;
}

.membership-status-card-label {
   font-size: 11px;
   font-weight: 700;
   letter-spacing: 1px;
   margin-bottom: 10px;
   opacity: .85;
   text-transform: uppercase;
}

.membership-status-chips,
.membership-profile-chips {
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
}

.membership-profile-chips {
   margin-bottom: 8px;
}

.membership-chip {
   align-items: center;
   border-radius: 999px;
   display: inline-flex;
   font-size: 11px;
   font-weight: 800;
   letter-spacing: .2px;
   line-height: 1;
   min-height: 26px;
   padding: 7px 12px;
}

.membership-chip-type {
   background: #e8f3ff;
   color: #155ec2;
}

.membership-chip-active {
   background: #dff7e7;
   color: #16833a;
}

.membership-member-panel {
   align-items: center;
   background: #fff;
   border: 1px solid #dbe4f0;
   border-radius: 8px;
   display: flex;
   gap: 18px;
   margin-bottom: 18px;
   padding: 16px;
}

.membership-member-photo {
   background: #f5f8fb;
   border: 1px solid #dbe4f0;
   border-radius: 8px;
   height: 126px;
   object-fit: cover;
   width: 106px;
}

.membership-view-title {
   color: #102033;
   font-size: 22px;
   font-weight: 800;
   margin: 4px 0 8px;
}

.membership-view-meta {
   color: #476078;
   display: flex;
   flex-wrap: wrap;
   font-size: 13px;
   font-weight: 700;
   gap: 12px;
}

.membership-section {
   background: #fff;
   border: 1px solid #dbe4f0;
   border-radius: 8px;
   margin-bottom: 14px;
   padding: 18px 0;
}

.membership-section-title {
   color: #476078;
   font-size: 11px;
   font-weight: 700;
   letter-spacing: 1.4px;
   margin-bottom: 16px;
   padding: 0 16px;
   text-transform: uppercase;
}

.membership-field {
   align-items: flex-start;
   display: grid;
   grid-template-columns: 260px 1fr;
   min-height: 26px;
   padding: 0 16px;
}

.membership-field span {
   color: #476078;
   font-weight: 700;
}

.membership-field strong {
   color: #102033;
   font-weight: 400;
   overflow-wrap: anywhere;
}

.membership-field.compact {
   grid-template-columns: 120px 1fr;
   padding: 0;
}

.membership-table-wrap {
   overflow-x: auto;
   padding: 0 16px;
}

.membership-table {
   border-collapse: collapse;
   color: #102033;
   font-size: 12px;
   width: 100%;
}

.membership-table th {
   background: #eef4fb;
   color: #39506a;
   font-size: 11px;
   font-weight: 800;
   letter-spacing: .8px;
   text-align: left;
   text-transform: uppercase;
}

.membership-table th,
.membership-table td {
   border: 1px solid #dbe4f0;
   padding: 10px;
   vertical-align: top;
}

.membership-empty {
   background: #f7fafc;
   color: #6b7c8f;
   font-weight: 600;
   padding: 18px !important;
   text-align: center;
}

.membership-check-grid {
   display: grid;
   gap: 12px;
   grid-template-columns: repeat(4, minmax(0, 1fr));
   padding: 0 16px;
}

.membership-check-item {
   align-items: center;
   background: #f7fafc;
   border: 1px solid #dbe4f0;
   border-radius: 8px;
   color: #476078;
   display: flex;
   font-weight: 700;
   gap: 10px;
   min-height: 42px;
   padding: 10px 12px;
}

.membership-check-item.active {
   background: #eefbf4;
   border-color: #b8e5c8;
   color: #16833a;
}

.membership-statement {
   color: #102033;
   line-height: 1.7;
   margin: 0 16px 12px;
}

.membership-card-grid {
   display: grid;
   gap: 14px;
   grid-template-columns: repeat(2, minmax(0, 1fr));
   padding: 0 16px;
}

.membership-person-card {
   background: #fbfdff;
   border: 1px solid #dbe4f0;
   border-radius: 8px;
   padding: 16px;
}

.membership-person-header {
   align-items: center;
   display: flex;
   justify-content: space-between;
   margin-bottom: 8px;
}

.membership-person-role {
   color: #476078;
   font-size: 11px;
   font-weight: 800;
   letter-spacing: 1.2px;
   text-transform: uppercase;
}

.membership-person-name {
   color: #102033;
   font-size: 16px;
   font-weight: 800;
   margin-bottom: 12px;
}

.membership-total-line {
   color: #102033;
   font-weight: 700;
   padding: 12px 16px 0;
   text-align: right;
}

.membership-actions {
   min-width: 140px;
   white-space: nowrap;
}

.outstanding-cell {
   min-width: 150px;
   padding: 6px 0;
}

.outstanding-detail {
   color: #26384f;
   font-size: 11px;
   font-weight: 700;
   line-height: 1.25;
   margin-top: 4px;
   white-space: normal;
}

.outstanding-chip {
   font-weight: 800;
   letter-spacing: 0;
}

.outstanding-chip.overdue {
   background-color: #661616 !important;
   box-shadow: 0 2px 6px rgba(136, 8, 8, 0.24);
}

@media (max-width: 768px) {
   .membership-brand-panel,
   .membership-brand-copy,
   .membership-member-panel {
      align-items: flex-start;
      flex-direction: column;
   }

   .membership-brand-status {
      text-align: left;
      width: 100%;
   }

   .membership-field {
      grid-template-columns: 1fr;
      row-gap: 2px;
   }

   .membership-check-grid,
   .membership-card-grid {
      grid-template-columns: 1fr;
   }
}
</style>
